import { Injectable } from '@angular/core';
import { DataStateChangeEventArgs, DataSourceChangedEventArgs } from '@syncfusion/ej2-angular-grids';
import { HttpBackend, HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { LocalStorageService } from '../localStorage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class ApprovalService extends Subject<DataStateChangeEventArgs> {
  private httpClient: HttpClient;
  constructor(
    private handler: HttpBackend,
    private http: HttpClient,
    private storageService: LocalStorageService,
  ) {
    super();
    this.httpClient = new HttpClient(handler);
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = `Error: ${error.error.message}`;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //  window.alert(errorMessage);
    console.log("Error:", errorMessage);
    return throwError(errorMessage);
  }

  //Get All approvals by Id Get
  getAllapprovals(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals`).pipe(catchError(this.handleError));
  }

  //get approvals by filterType
  getApprovals(filterType): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals?filterType=${filterType}`).pipe(catchError(this.handleError));
  }

  //get approvals by filterType
  getTSApprovals(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals?filterType=timesheetapproval&userId=0`).pipe(catchError(this.handleError));
  }

  //get approvals by filterType
  getNewTSApprovals(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals?filterType=timesheetv2approval&userId=0`).pipe(catchError(this.handleError));
  }

  //get timesheet approval for date filters
  getTimesheetApprovalByDate(startDate, endDate): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals?filterType=timesheetapproval&startDate=${startDate}&endDate=${endDate}`)
  }

  //get timesheet approval for date filters
  getNewTimesheetApprovalByDate(startDate, endDate): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals?filterType=timesheetv2approval&startDate=${startDate}&endDate=${endDate}`)
  }

  //get timesheet approval for date filters and Users
  getTimesheetApprovalByDateAndUser(userId, startDate, endDate): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals?filterType=timesheetapproval&userId=${userId}&startDate=${startDate}&endDate=${endDate}`)
  }

  //get timesheet approval for date filters and Users
  getNewTimesheetApprovalByDateAndUser(userId, startDate, endDate): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals?filterType=timesheetv2approval&userId=${userId}&startDate=${startDate}&endDate=${endDate}`)
  }

  //get timesheet approval for date filters and Users
  getNewTimesheetApprovalByUser(userId): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals?filterType=timesheetv2approval&userId=${userId}`)
  }

  //Get Leave application data by id
  public getSelectedLeaveApplication(id: number) {
    return this.http.get(`${environment.apiUrl}/leaveApplications/${id}`).pipe(catchError(this.handleError));
  }

  public addleaveAppRates(addladata: Object, id: string) {
    console.log("addleaveAppRates: ", addladata);
    return this.http
      .put<any>(`${environment.apiUrl}/leaveApplications/${id}`, addladata,
    )
      .pipe(
        catchError(this.handleError),
      );
  }

  //Update Overtime by Id Put
  updateOvertime(user: Object, id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/overtimes/${id}`, user).pipe(catchError(this.handleError));
  }

  //Get All overtime 
  getAllOvertime(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/overtimes`).pipe(catchError(this.handleError));
  }

  public getProjectDetails() {
    return this.http
      .get<any>(`${environment.apiUrl}/resourceAllocationProjects`).pipe(catchError(this.handleError));
  }

  public getUserDetails() {
    return this.http
      .get<any>(`${environment.apiUrl}/userSummary`)
      .pipe(catchError(this.handleError));
  }

  // Create Timesheet
  createTimesheet(user: Object): Observable<Object> {
    console.log("In createTimesheet method, Timesheet: ", user);
    return this.http.post(`${environment.apiUrl}/timesheets`, user).pipe(catchError(this.handleError));
  }

  // Get Contact by Id Get
  getTimesheet(id: number): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/timesheets/${id}`).pipe(catchError(this.handleError));
  }
  //Update Contact by Id Put
  updateTimesheet(user: Object, id: number): Observable<Object> {
    console.log("In createUser method, user: ", user);
    return this.http.put(`${environment.apiUrl}/timesheets/${id}`, user).pipe(catchError(this.handleError));
  }

  //Get All manualApproval by
  manualApproval(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvals`).pipe(catchError(this.handleError));
  }

  //Manual Approval by Id Get
  manualApprovalById(id: number): Observable<Object> {
    return this.http.put(`${environment.apiUrl}/manualLeaves/${id}`, {}).pipe(catchError(this.handleError));
  }

  //Manual leave cancel by Id Get
  manualLeaveCanelById(id: number): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/manualLeaves/${id}`, {}).pipe(catchError(this.handleError));
  }

  //Get All regularizationsApproval by
  regularizationsApproval(userId: any, date: any): Observable<Object> {
    return this.http.put(`${environment.apiUrl}/regularizations?userId=${userId}&date=${date}`, {}).pipe(catchError(this.handleError));
  }

  //regularizations leave cancel by Id Get
  regularizationsLeaveCancelById(userId: number, date: any): Observable<Object> {
    return this.http.delete(`${environment.apiUrl}/regularizations?userId=${userId}&date=${date}`, {}).pipe(catchError(this.handleError));
  }

  bulkStatusUpdateForLeaveApplications(data: any): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/bulkStatusUpdateForLeaveApplications`, data).pipe(catchError(this.handleError));
  }

  bulkStatusUpdateForManualLeaves(data: any): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/bulkStatusUpdateForManualLeaves`, data).pipe(catchError(this.handleError));
  }

  approveShortLeaves(data: any): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/approveShortLeaves`, data).pipe(catchError(this.handleError));
  }

  rejectShortLeaves(data: any): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/rejectShortLeaves`, data).pipe(catchError(this.handleError));
  }

  bulkApproveRegularizations(data: any): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/bulkApproveRegularizations`, data).pipe(catchError(this.handleError));
  }

  bulkRejectRegularizations(data: any): Observable<Object> {
    return this.http.post(`${environment.apiUrl}/bulkRejectRegularizations`, data).pipe(catchError(this.handleError));
  }

  approvalCounts(): Observable<Object> {
    return this.http.get(`${environment.apiUrl}/approvalCounts`).pipe(catchError(this.handleError));
  }
}